import React from 'react';
import { Answers, ListField } from './types/form';
import iconsSvg from '../../images/icons.svg';

type ListFieldQuestionProps = {
    answer?: string[];
    field: ListField;
    setAnswers: React.Dispatch<React.SetStateAction<Answers>>;
    id:
        | 'area'
        | 'house_age'
        | 'house_type'
        | 'house_isolation'
        | 'energy_source'
        | 'heating_type';
    icons?: { [key: string]: string };
};

export default function ListFieldQuestion({
    answer = [],
    field,
    setAnswers,
    id,
    icons = undefined,
}: ListFieldQuestionProps) {
    return (
        <>
            {field.child.choices.map((choice) => {
                if (!choice.value) return null;

                return (
                    <li
                        className="form-option form-option--icon"
                        key={`list-item-${choice.value}`}
                    >
                        <input
                            className="required form-option__input"
                            id={choice.value}
                            type="checkbox"
                            key={`button-area-${choice.value}`}
                            name={id}
                            data-disabledbyother="1"
                            value={choice.value}
                            checked={answer && answer.includes(choice.value)}
                            onChange={() => {
                                setAnswers((prev) => {
                                    if (prev[id]) {
                                        const prevAnswer = prev[id] as string[];
                                        if (choice.value === 'none') {
                                            return {
                                                ...prev,
                                                [id]: [choice.value],
                                            };
                                        }

                                        const filteredAnswer =
                                            prevAnswer.filter(
                                                (i) => i !== 'none'
                                            );
                                        if (
                                            filteredAnswer.includes(
                                                choice.value
                                            )
                                        ) {
                                            return {
                                                ...prev,
                                                [id]: [
                                                    ...filteredAnswer.filter(
                                                        (i) =>
                                                            i !== choice.value
                                                    ),
                                                ],
                                            };
                                        }
                                        return {
                                            ...prev,
                                            [id]: [
                                                ...filteredAnswer,
                                                choice.value,
                                            ],
                                        };
                                    }
                                    return {
                                        ...prev,
                                        [id]: [choice.value],
                                    };
                                });
                            }}
                        />
                        <label
                            className="form-option__label"
                            htmlFor={choice.value}
                        >
                            <span className="form-option__text">
                                {choice.display_name}
                            </span>
                            {icons && (
                                <span className="form-option__icon-wrapper">
                                    <svg className="form-option__icon">
                                        <use
                                            href={`${iconsSvg}#${icons[choice.value]}`}
                                        />
                                    </svg>
                                </span>
                            )}
                        </label>
                    </li>
                );
            })}
        </>
    );
}
